
import clienteAxios from "../config/axios";

export const getAllTarea = async () => {
    return clienteAxios.get('/tarea');
};
export const addTarea = async (tarea) => {
    return await clienteAxios.post('/tarea',{tarea});
}
export const updateTarea = async (tarea) => {
    return await clienteAxios.put(`tarea/${tarea.id}`,{tarea});
}
export const deleteTarea = async (tareaID,tDocID) => {
    return await clienteAxios.delete(`tarea/${tareaID}`,{data: {tDocID:tDocID}});
}